import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import type { MarketingTemplatePreset } from './get-campaign-templates';

export const GET_CAMPAIGN_TEMPLATE = 'api/marketing-template/get-template-preset';

type GetSavedCampaignTemplatePayload = {
  MarketingTemplatePresetId: number | null;
};

export const marketingTemplateQueryKey = ['marketing-templates'];

export function useGetCampaignTemplateQuery({
  marketingTemplatePresetId,
  enabled = true,
}: {
  enabled?: boolean;
  marketingTemplatePresetId: number | null;
}) {
  return useQuery({
    queryKey: [...marketingTemplateQueryKey, 'saved-template', marketingTemplatePresetId],
    queryFn: async () =>
      postData<GetSavedCampaignTemplatePayload, MarketingTemplatePreset>({
        endpoint: GET_CAMPAIGN_TEMPLATE,
        payload: { MarketingTemplatePresetId: marketingTemplatePresetId },
      }),
    enabled,
  });
}
